import { render, staticRenderFns } from "./CouponsHeader.vue?vue&type=template&id=21c7e04f&scoped=true"
import script from "./CouponsHeader.vue?vue&type=script&lang=ts"
export * from "./CouponsHeader.vue?vue&type=script&lang=ts"
import style0 from "./CouponsHeader.vue?vue&type=style&index=0&id=21c7e04f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21c7e04f",
  null
  
)

export default component.exports